'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _System = require('@olxbr/olx-icons/dist/System');

var System = _interopRequireWildcard(_System);

var _style = require('./style');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-undef */
/* eslint-disable no-restricted-globals */
var waitEvent = function waitEvent(event) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  callback();

  if (!event.metaKey && !event.ctrlKey) {
    event.preventDefault();

    var url = event.target.getAttribute('href');
    setTimeout(function () {
      location.href = url;
    }, 0);
  }
};

function MenuItem(_ref) {
  var href = _ref.href,
      onClick = _ref.onClick,
      label = _ref.label,
      iconName = _ref.iconName,
      isDropDown = _ref.isDropDown;

  var IconComponent = System[iconName];
  if (!IconComponent) {
    throw new Error('Invalid Icon ' + iconName);
  }

  var handleClick = function handleClick(event) {
    if (onClick) {
      waitEvent(event, onClick);
    }
  };

  return _react2.default.createElement(
    _style.LinkMenuStyled,
    { href: href, onClick: handleClick },
    _react2.default.createElement(
      _style.IconContainer,
      null,
      _react2.default.createElement(IconComponent, { size: isDropDown ? 20 : 24 })
    ),
    label
  );
}

MenuItem.propTypes = {
  href: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string.isRequired,
  iconName: _propTypes2.default.string.isRequired,
  isDropDown: _propTypes2.default.bool.isRequired,
  onClick: _propTypes2.default.func
};

exports.default = MenuItem;